import { apis } from "apis";
import ServiceBase from "./service-base";
import IHttpResponse from "src/http/http-response";
import HttpClient from "src/http/http-client";
import { IMemberManagementModel, IMemberTagModel} from "src/model";
import { ServiceInjectable } from "src/utils/services";

/**
 * 用户类
 * @class
 * @version 1.0.0
 */
@ServiceInjectable()
export default class MemberService extends ServiceBase
{
    /**
     * 获取客户管理list
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getMemberList(data: IMemberManagementModel): Promise<IHttpResponse>
    {
        let response = await this.apis.getMemberList({ 
            data: data
        });
        return response;
    }

     /**
     * 获取用户详情
     * @param id 用户id
     * @public
     * @returns {Promise<IHttpResponse>}
     */
      public async getMemberDetail(id: number): Promise<IHttpResponse>
      {
          let response = await this.apis.getMemberDetail({ 
              urlPath: { id: id } 
          });
          return response;
      }
    /**
     * 为会员添加标签
     * @param data
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async memberAddTags(data: any): Promise<IHttpResponse>
    {
        let response = await this.apis.memberAddTags({
            data
        });
        return response;
    }
     /**
     * 加入黑名单
     * @param data
     * @public
     * @returns {Promise<IHttpResponse>}
     */
      public async addToBlack(data: any): Promise<IHttpResponse>
      {
          let response = await this.apis.addToBlack({
              data
          });
          return response;
      }
      /**
     * 为单个会员添加标签
     * @param data
     * @public
     * @returns {Promise<IHttpResponse>}
     */
       public async memberOneAddTag(data: any): Promise<IHttpResponse>
       {
           let response = await this.apis.memberOneAddTag({
               data
           });
           return response;
       }
     /**
     * 移出黑名单
     * @param data
     * @public
     * @returns {Promise<IHttpResponse>}
     */
          public async removeFromBlack(data: any): Promise<IHttpResponse>
          {
              let response = await this.apis.removeFromBlack({
                  data
              });
              return response;
          }




    /**
     * 添加会员标签
     * @param data
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async addMemberTag(data: IMemberTagModel): Promise<IHttpResponse>
    {
        let response = await this.apis.addMemberTag({ data });
        return response;
    }
    /**
     * 编辑会员标签
     * @param data
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async updateMemberTag(data: IMemberTagModel): Promise<IHttpResponse>
     {
         let response = await this.apis.updateMemberTag({ data });
         return response;
     }
     /**
     * 删除会员标签
     * @param id 用户id
     * @public
     * @returns {Promise<IHttpResponse>}
     */
       public async deleteMemberTag(id: number): Promise<IHttpResponse>
       {
           let response = await this.apis.deleteMemberTag({ 
               urlPath: { id: id } 
           });
           return response;
       }
        /**
         * 查询会员标签列表
         * @param data
         * @public
         * @returns {Promise<IHttpResponse>}
         */
         public async memberTagPagingList(data: any): Promise<IHttpResponse>
         {
             let response = await this.apis.memberTagPagingList({
                data
             });
             return response;
         }

         /**
         * 查询会员标签列表 -- 不分页
         * @param data
         * @public
         * @returns {Promise<IHttpResponse>}
         */
          public async memberTagList(): Promise<IHttpResponse>
          {
              let response = await this.apis.memberTagList({});
              return response;
          }

}